// extracted by mini-css-extract-plugin
module.exports = {"loader":"appLoader_loader__26KVY","spin":"appLoader_spin__2BQBp","appOverlay":"appLoader_appOverlay__2ziiu"};